import { environment } from 'src/environments/environment';

import {
  Component,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Input,
  HostListener,
} from '@angular/core';
import { OcrPlusComponent } from '../ocr-plus/ocr-plus.component';

@Component({
  selector: 'app-ocr-plus-canvas',
  templateUrl: './ocr-plus-canvas.component.html',
  styleUrls: ['./ocr-plus-canvas.component.css'],
})
export class OcrPlusCanvasComponent {
  /** Template reference to the canvas element */
  @ViewChild('canvasEl') canvasEl: ElementRef;
  @ViewChild('canvasAnimationEl') canvasAnimationEl: ElementRef;

  @Input() imageURL: string;
  @Input() fileName: string;
  /** Canvas 2d context */
  context: CanvasRenderingContext2D;

  imageObj = new Image();
  // imageName = "../assets/550.jpg";
  width = window.innerWidth * 0.6;
  height = window.innerHeight;
  canvas: HTMLCanvasElement;
  ocr: any;
  loadingFlag = false;
  lastItem: any;
  wordClicked: (word: any) => void;

  ocrPlus: OcrPlusComponent;
  jsonData: any;
  canvasAnimation: HTMLCanvasElement;
  contextAnimation: CanvasRenderingContext2D;

  constructor() {}

  ngOnInit(): void {}
  ngAfterViewInit() {
    this.canvas = this.canvasEl.nativeElement as HTMLCanvasElement;
    if (this.canvasEl.nativeElement) {
      const newCtx = (
        this.canvasEl.nativeElement as HTMLCanvasElement
      ).getContext('2d');
      if (newCtx) this.context = newCtx;
    }
    this.canvasAnimation = this.canvasAnimationEl
      .nativeElement as HTMLCanvasElement;
    if (this.canvasAnimationEl.nativeElement) {
      const newCtx = (
        this.canvasAnimationEl.nativeElement as HTMLCanvasElement
      ).getContext('2d');
      if (newCtx) this.contextAnimation = newCtx;
    }
    this.play();
  }

  restart() {
    this.unchooseTr();
    this.ocr = null;
    // this.width = window.innerWidth * 0.6;
    // this.height = window.innerHeight;        
  }


  playMatrixAnimation() {
    const canvas = this.canvasAnimation;
    const ctx = this.contextAnimation;

    // Set the canvas size
    canvas.width = this.width;
    canvas.height = this.height;    


            // Matrix characters
            const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

            // Animation variables
            const fontSize = 20;
            const columns = Math.floor(canvas.width / fontSize);
            const rows = Math.floor(canvas.height / fontSize);
            const matrix :any= [];
            const speedX = 1; // Speed of movement in X direction
            const speedY = 2; // Speed of movement in Y direction
            const fadeSpeed = 0.02; // Speed of fading
            const fadeColor = `rgba(0, 0, 0, ${fadeSpeed})`; // Color used to fade characters

            for (let i = 0; i < columns; i++) {
                matrix[i] = [];
                for (let j = 0; j < rows; j++) {
                    matrix[i][j] = {
                        character: characters[Math.floor(Math.random() * characters.length)],
                        positionY: Math.random() * canvas.height,
                        opacity: 1
                    };
                }
            }

            function draw() {
                ctx.fillStyle = "rgba(0, 0, 0, 0.1)";
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.fillStyle = "#0F0";
                ctx.font = `${fontSize}px Courier New`;

                for (let i = 0; i < columns; i++) {
                    for (let j = 0; j < rows; j++) {
                        const { character, positionY, opacity } = matrix[i][j];

                        ctx.globalAlpha = opacity;
                        ctx.fillText(character, i * fontSize, positionY);

                        matrix[i][j].positionY += speedY;

                        if (positionY > canvas.height || Math.random() < fadeSpeed) {
                            matrix[i][j].character = characters[Math.floor(Math.random() * characters.length)];
                            matrix[i][j].positionY = -fontSize;
                            matrix[i][j].opacity = 1;
                        } else {
                            matrix[i][j].opacity -= fadeSpeed;
                        }
                    }
                }

                requestAnimationFrame(draw);
            }

            // // Start the animation
            draw();
  }

  /**
   * Draws something using the context we obtained earlier on
   */
  draw() {
    this.context.drawImage(this.imageObj, 0, 0, this.width, this.height);
    this.drawItem();
  }


  play() {
    this.imageObj.onload = this.onLoadImg.bind(this);
    this.imageObj.src = this.imageURL;


    // Listen for mouse down
    this.canvas.addEventListener('mousedown', (event) => {
      if (!this.ocrPlus) return;
      let x = event.offsetX;
      let y = event.offsetY;
      [x, y] = this.scaleFromCanvas(x, y); 
      this.ocrPlus.mouseDown(x, y);
    });
    // Listen for mouse moves
    this.canvas.addEventListener('mousemove', (event) => {
      if (!this.ocr) return;
      let foundFlag = false;

      if (!foundFlag) {
        this.clear();
      }
    });
  }

  clear() {
    this.draw();
  }

  drawRect(x, y, w, h, strokeStyle = '') {
    this.context.lineWidth = 3;
    this.context.setLineDash([6]);
    this.context.strokeStyle = strokeStyle;
    this.context.beginPath();
    this.context.rect(x, y, w, h);
    this.context.stroke();
  }

  drawLine(x1, y1, x2, y2, strokeStyle = '') {
    this.context.lineWidth = 3;
    this.context.setLineDash([6]);
    this.context.strokeStyle = strokeStyle;
    this.context.beginPath();
    this.context.moveTo(x1, y1);
    this.context.lineTo(x2, y2);
    this.context.stroke();
  }

  getItemBox(item) {
    if (item.box) {
      return item.box;
    } else {
      return item.value.word.box;
    }
  }

  drawItemWord(item, color, sideFlag = false): [number, number] | null {
    let box = this.getItemBox(item);
    if (box == null) return null;

    return this.drawItemBox(box, color);
  }

  drawItemBox(box, color): [number, number] | null {
    if (box == null) return null;
    let x = box[0],
      y = box[1],
      width = box[2],
      height = box[3];

    let xx = x,
      yy = y,
      ww = width,
      hh = height;

      console.log("x,y",xx,yy);
      console.log("width,height",ww,hh);
      [x, y] = this.scaleToCanvas(xx, yy);      
      [width, height] = this.scaleToCanvas(ww, hh);
      // console.log("x,y",x,y);
      // console.log("width,height",width,height);

    this.drawRect(x, y, width - x, height - y, color);
    return [x, y];
  }

  setOcrPlus(ocrPlus: OcrPlusComponent) {
    this.ocrPlus = ocrPlus;
    const jsonData = ocrPlus.jsonData;
    this.jsonData = jsonData;

    // this.imageObj.width = this.jsonData.width;
    // this.imageObj.height = this.jsonData.height;    

    this.ocr = jsonData.ocr;
    if (jsonData.imgBase64 && jsonData.imgBase64 != '')
      this.imageURL = `data:image/png;base64, ${jsonData.imgBase64}`;
    this.play();
    this.playMatrixAnimation();
  }

    // on load image handler
  onLoadImg() {
    // this.height = (this.imageObj.height / this.imageObj.width) * this.width;
    // console.log("image src", this.imageObj.src)
    console.log('this.imageObj width height', this.imageObj.width, this.imageObj.height, this.imageObj.width/this.imageObj.height); //
    console.log('this.canvas width height', this.canvas.width, this.canvas.height, this.canvas.width/this.canvas.height); //

    setTimeout(this.draw.bind(this), 100);    
  }

  scaleToCanvas(x: any, y: any): any {
    x *= this.width // * this.imageObj.width;
    y *= this.height //* this.imageObj.height;

    return [x, y];
  }
  scaleFromCanvas(x: any, y: any): any {
      x /= this.width;
      y /= this.height;

    return [x, y];
  }



  unchooseTr() {
    this.lastItem = null;
  }

  drawItem(): [number, number] | null {
    if (this.lastItem) {
      let item = this.lastItem;
      const point = this.drawItemBox(item.bbox, 'red');
      return point;
    }
    return null;
  }

  itemOver(item: any): [number, number] | null {
    this.clear();
    this.lastItem = item;
    const point = this.drawItem();
    this.scrollToPoint(point);
    return point;
  }

  scrollToPoint(point: [number, number] | null) {
    if (point) {
      const elem = document.getElementsByClassName('canvasCompContain');
      elem[0].scroll({
        left: point[0],
        top: point[1] - 250,
        behavior: 'smooth',
      });
    }
  }
}
